import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

@Component({
	selector: 'app-pix-receive-payment-list-choice-modal',
	templateUrl: './choice-modal.component.html',
	styleUrls: ['./choice-modal.component.styl'],
})
export class PixReceivePaymentListChoiceComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<PixReceivePaymentListChoiceComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {

	}

	ngOnInit(): void {
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/receive-payment/list/choice-modal/choice-modal.component.ts